export enum RecordTypeEnum {
  ABORTION = '2',
  AMPUTATION = '3',
  DEATH = '1'
}
